import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { format, subDays, startOfMonth, endOfMonth } from "date-fns";

/** Reusable date-range filter pill bar.
 *  Calls onChange({ start_date, end_date }) whenever the user picks a range.
 */
export default function DashboardFilters({ value, onChange }) {
  const today = new Date();
  const presets = [
    { id: "today", label: "Today", days: 0 },
    { id: "7d", label: "Last 7 days", days: 7 },
    { id: "30d", label: "Last 30 days", days: 30 },
    { id: "90d", label: "Last 90 days", days: 90 },
    { id: "month", label: "This month", days: -1 },
  ];
  const [preset, setPreset] = useState("30d");
  const [start, setStart] = useState(value?.start_date || format(subDays(today, 30), "yyyy-MM-dd"));
  const [end, setEnd] = useState(value?.end_date || format(today, "yyyy-MM-dd"));

  useEffect(() => {
    onChange?.({ start_date: start, end_date: end });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start, end]);

  const applyPreset = (p) => {
    setPreset(p.id);
    if (p.id === "month") {
      setStart(format(startOfMonth(today), "yyyy-MM-dd"));
      setEnd(format(endOfMonth(today), "yyyy-MM-dd"));
    } else {
      setStart(format(subDays(today, p.days), "yyyy-MM-dd"));
      setEnd(format(today, "yyyy-MM-dd"));
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="dashboard-filters">
      <div className="flex flex-wrap gap-1.5">
        {presets.map((p) => (
          <button
            key={p.id}
            onClick={() => applyPreset(p)}
            data-testid={`filter-preset-${p.id}`}
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
              preset === p.id
                ? "bg-[#339999] text-white border-[#339999]"
                : "bg-white text-slate-600 border-slate-200 hover:border-[#339999]/60"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <Input
          type="date"
          value={start}
          onChange={(e) => { setPreset("custom"); setStart(e.target.value); }}
          className="w-40 h-8 text-xs"
          data-testid="filter-start-date"
        />
        <span className="text-xs text-slate-400">to</span>
        <Input
          type="date"
          value={end}
          onChange={(e) => { setPreset("custom"); setEnd(e.target.value); }}
          className="w-40 h-8 text-xs"
          data-testid="filter-end-date"
        />
      </div>
    </div>
  );
}
